import { render } from "./StampItem.vue?vue&type=template&id=1343f195&scoped=true"
import script from "./StampItem.vue?vue&type=script&lang=js"
export * from "./StampItem.vue?vue&type=script&lang=js"

import "./StampItem.vue?vue&type=style&index=0&id=1343f195&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1343f195"]])

export default __exports__